import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["dir", "lang"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12 3C6.5 3 2 6.9 2 11.7c0 2.3 1 4.4 2.8 6L4 21l3.9-1.6c1.2.4 2.6.7 4.1.7 5.5 0 10-3.9 10-8.7S17.5 3 12 3z"
  })
], -1 /* HOISTED */)
const _hoisted_4 = { class: "txc-launcher__label" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "txc-head" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "txc-head__text" }
const _hoisted_10 = ["href", "title", "aria-label"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.6.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.3-.4.3-.4.7-1.4.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.3.8 3.2.7.5-.1 1.5-.6 1.8-1.2s.2-1.1.1-1.2-.2-.1-.4-.2z"
  })
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["title", "aria-label"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
  })
], -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    d: "M6 9l6 6 6-6"
  })
], -1 /* HOISTED */)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  ref: "scroller",
  class: "txc-body",
  "aria-live": "polite"
}
const _hoisted_20 = {
  key: 0,
  class: "txc-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "txc-spin" }, null, -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "txc-center txc-stack"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = { class: "txc-muted" }
const _hoisted_26 = ["href"]
const _hoisted_27 = {
  key: 2,
  class: "txc-center txc-stack"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "txc-msg txc-msg--them" }
const _hoisted_30 = {
  key: 0,
  class: "txc-author"
}
const _hoisted_31 = { class: "txc-tag" }
const _hoisted_32 = { class: "txc-bubble" }
const _hoisted_33 = {
  key: 0,
  class: "txc-note"
}
const _hoisted_34 = ["onSubmit"]
const _hoisted_35 = ["readonly"]
const _hoisted_36 = ["readonly"]
const _hoisted_37 = ["maxlength"]
const _hoisted_38 = {
  key: 0,
  class: "txc-error",
  role: "alert"
}
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 1,
  class: "txc-muted txc-small"
}
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 0,
  class: "txc-author"
}
const _hoisted_43 = {
  key: 0,
  class: "txc-tag"
}
const _hoisted_44 = {
  key: 1,
  class: "txc-tag"
}
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = {
  key: 1,
  class: "txc-sources"
}
const _hoisted_47 = ["href"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "txc-fb"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "txc-muted"
}
const _hoisted_53 = { class: "txc-time" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 1,
  class: "txc-bubble txc-bubble--pending"
}
const _hoisted_56 = {
  key: 0,
  class: "txc-msg txc-msg--them"
}
const _hoisted_57 = { class: "txc-author" }
const _hoisted_58 = { class: "txc-tag" }
const _hoisted_59 = { class: "txc-bubble txc-bubble--ai txc-bubble--stream" }
const _hoisted_60 = {
  key: 0,
  class: "txc-stream"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", {
  class: "txc-dots",
  "aria-label": "…"
}, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i")
], -1 /* HOISTED */)
const _hoisted_62 = {
  key: 1,
  class: "txc-typing"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "txc-dots" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createElementVNode("i")
], -1 /* HOISTED */)
const _hoisted_64 = {
  key: 2,
  class: "txc-note"
}
const _hoisted_65 = {
  key: 3,
  class: "txc-ended"
}
const _hoisted_66 = { class: "txc-muted" }
const _hoisted_67 = { class: "txc-stars" }
const _hoisted_68 = ["aria-label", "onClick"]
const _hoisted_69 = {
  key: 1,
  class: "txc-muted"
}
const _hoisted_70 = {
  key: 1,
  class: "txc-foot"
}
const _hoisted_71 = {
  key: 0,
  class: "txc-chips",
  role: "group"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 1,
  class: "txc-disclaimer"
}
const _hoisted_74 = {
  key: 2,
  class: "txc-confirm"
}
const _hoisted_75 = ["onSubmit"]
const _hoisted_76 = ["title"]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    d: "M21.4 11.1l-9.2 9.2a6 6 0 0 1-8.5-8.5l9.2-9.2a4 4 0 0 1 5.7 5.7l-9.2 9.2a2 2 0 0 1-2.8-2.8l8.5-8.5"
  })
], -1 /* HOISTED */)
const _hoisted_78 = { class: "txc-compose__input" }
const _hoisted_79 = {
  key: 0,
  class: "txc-chip"
}
const _hoisted_80 = ["placeholder", "maxlength", "aria-label", "onKeydown"]
const _hoisted_81 = ["disabled", "aria-label"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "18",
  height: "18",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M3 20l18-8L3 4v6l12 2-12 2z"
  })
], -1 /* HOISTED */)
const _hoisted_83 = [
  _hoisted_82
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["txc-root", $setup.rootClass]),
        dir: $setup.dir,
        lang: $setup.lang,
        style: _normalizeStyle({ '--txc-brand': $setup.cfg.brand.color })
      }, [
        (!$props.inline && !$setup.open)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "txc-launcher",
              "aria-label": $setup.t('launcher'),
              onClick: _cache[0] || (_cache[0] = $event => ($setup.setOpen(true)))
            }, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString($setup.cfg.title || $setup.t("launcher")), 1 /* TEXT */),
              ($setup.unread)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "txc-unread",
                    "aria-label": $setup.unread + ' ' + $setup.t('unread')
                  }, _toDisplayString($setup.unread), 9 /* TEXT, PROPS */, _hoisted_5))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_2))
          : _createCommentVNode("v-if", true),
        ($setup.open || $props.inline)
          ? (_openBlock(), _createElementBlock("section", {
              key: 1,
              class: "txc-panel",
              role: "dialog",
              "aria-label": $setup.cfg.title
            }, [
              _createElementVNode("header", _hoisted_7, [
                _createElementVNode("img", {
                  src: $setup.cfg.brand.logo,
                  alt: "",
                  class: "txc-logo"
                }, null, 8 /* PROPS */, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("strong", null, _toDisplayString($setup.cfg.title || $setup.t("launcher")), 1 /* TEXT */),
                  _createElementVNode("small", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["txc-dot", { on: $setup.cfg.online }])
                    }, null, 2 /* CLASS */),
                    _createTextVNode(_toDisplayString($setup.headerStatus), 1 /* TEXT */)
                  ])
                ]),
                ($setup.cfg.whatsapp_url)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: $setup.cfg.whatsapp_url,
                      target: "_blank",
                      rel: "noopener",
                      class: "txc-iconbtn txc-wa",
                      title: $setup.t('whatsapp'),
                      "aria-label": $setup.t('whatsapp')
                    }, _hoisted_12, 8 /* PROPS */, _hoisted_10))
                  : _createCommentVNode("v-if", true),
                ($setup.phase === 'chat' && $setup.hasChat)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "txc-iconbtn",
                      title: $setup.t('end'),
                      "aria-label": $setup.t('end'),
                      onClick: _cache[1] || (_cache[1] = $event => ($setup.confirmEnd = true))
                    }, _hoisted_15, 8 /* PROPS */, _hoisted_13))
                  : _createCommentVNode("v-if", true),
                (!$props.inline)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "txc-iconbtn",
                      "aria-label": $setup.t('close'),
                      onClick: _cache[2] || (_cache[2] = $event => ($setup.setOpen(false)))
                    }, _hoisted_18, 8 /* PROPS */, _hoisted_16))
                  : _createCommentVNode("v-if", true)
              ]),
              ($setup.banner)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["txc-banner", 'txc-banner--' + $setup.banner.kind]),
                    role: "status"
                  }, _toDisplayString($setup.banner.text), 3 /* TEXT, CLASS */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_19, [
                ($setup.phase === 'loading')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                  : ($setup.phase === 'login')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("p", null, _toDisplayString($setup.t("login")), 1 /* TEXT */),
                        _createElementVNode("a", {
                          class: "txc-btn",
                          href: $setup.loginUrl
                        }, _toDisplayString($setup.t("login_btn")), 9 /* TEXT, PROPS */, _hoisted_24),
                        ($setup.cfg.whatsapp_url)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("span", _hoisted_25, _toDisplayString($setup.t("or")), 1 /* TEXT */),
                              _createElementVNode("a", {
                                class: "txc-btn txc-btn--wa",
                                href: $setup.cfg.whatsapp_url,
                                target: "_blank",
                                rel: "noopener"
                              }, _toDisplayString($setup.t("whatsapp")), 9 /* TEXT, PROPS */, _hoisted_26)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : ($setup.phase === 'whatsapp')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("p", null, _toDisplayString($setup.cfg.greeting), 1 /* TEXT */),
                          _createElementVNode("a", {
                            class: "txc-btn txc-btn--wa",
                            href: $setup.cfg.whatsapp_url,
                            target: "_blank",
                            rel: "noopener"
                          }, _toDisplayString($setup.t("whatsapp")), 9 /* TEXT, PROPS */, _hoisted_28)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_29, [
                            ($setup.cfg.welcome)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_30, [
                                  _createElementVNode("span", _hoisted_31, _toDisplayString($setup.t("bot_badge")), 1 /* TEXT */),
                                  _createTextVNode(_toDisplayString($setup.cfg.welcome.name), 1 /* TEXT */)
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_32, _toDisplayString(($setup.cfg.welcome && $setup.cfg.welcome.message) || $setup.cfg.greeting), 1 /* TEXT */)
                          ]),
                          (!$setup.cfg.online && $setup.cfg.offline_message)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString($setup.cfg.offline_message), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          ($setup.phase === 'prechat')
                            ? (_openBlock(), _createElementBlock("form", {
                                key: 1,
                                class: "txc-form",
                                onSubmit: _withModifiers($setup.startGuest, ["prevent"])
                              }, [
                                _createElementVNode("label", null, [
                                  _createElementVNode("span", null, _toDisplayString($setup.t("name")), 1 /* TEXT */),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "txc-name",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.form.name) = $event)),
                                    required: "",
                                    maxlength: "80",
                                    autocomplete: "name",
                                    readonly: $setup.cfg.prefill.locked
                                  }, null, 8 /* PROPS */, _hoisted_35), [
                                    [
                                      _vModelText,
                                      $setup.form.name,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("span", null, _toDisplayString($setup.t("email")), 1 /* TEXT */),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "txc-email",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.form.email) = $event)),
                                    type: "email",
                                    required: "",
                                    autocomplete: "email",
                                    readonly: $setup.cfg.prefill.locked
                                  }, null, 8 /* PROPS */, _hoisted_36), [
                                    [
                                      _vModelText,
                                      $setup.form.email,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("span", null, [
                                    _createTextVNode(_toDisplayString($setup.t("phone")) + " ", 1 /* TEXT */),
                                    _createElementVNode("em", null, "(" + _toDisplayString($setup.t("optional")) + ")", 1 /* TEXT */)
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    id: "txc-phone",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.form.phone) = $event)),
                                    type: "tel",
                                    maxlength: "20",
                                    autocomplete: "tel",
                                    dir: "ltr"
                                  }, null, 512 /* NEED_PATCH */), [
                                    [
                                      _vModelText,
                                      $setup.form.phone,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ])
                                ]),
                                _createElementVNode("label", null, [
                                  _createElementVNode("span", null, _toDisplayString($setup.t("message")), 1 /* TEXT */),
                                  _withDirectives(_createElementVNode("textarea", {
                                    id: "txc-first",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.form.message) = $event)),
                                    rows: "3",
                                    required: "",
                                    maxlength: $setup.cfg.max_length
                                  }, null, 8 /* PROPS */, _hoisted_37), [
                                    [_vModelText, $setup.form.message]
                                  ])
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.form.website) = $event)),
                                  class: "txc-hp",
                                  tabindex: "-1",
                                  autocomplete: "off",
                                  "aria-hidden": "true",
                                  name: "website"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, $setup.form.website]
                                ]),
                                ($setup.error)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString($setup.error), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                _createElementVNode("button", {
                                  class: "txc-btn",
                                  disabled: $setup.busy
                                }, _toDisplayString($setup.busy ? $setup.t("sending") : $setup.t("start")), 9 /* TEXT, PROPS */, _hoisted_39),
                                ($setup.cfg.privacy_note)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString($setup.cfg.privacy_note), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true)
                              ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_34))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (m) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, {
                                    key: m.id
                                  }, [
                                    (m.sender_type === 'System')
                                      ? (_openBlock(), _createElementBlock("p", {
                                          key: 0,
                                          class: "txc-sys",
                                          innerHTML: m.content
                                        }, null, 8 /* PROPS */, _hoisted_41))
                                      : (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: _normalizeClass(["txc-msg", m.from_customer ? 'txc-msg--me' : 'txc-msg--them'])
                                        }, [
                                          (!m.from_customer)
                                            ? (_openBlock(), _createElementBlock("small", _hoisted_42, [
                                                (m.sender_type === 'AI')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString($setup.t("ai_badge")), 1 /* TEXT */))
                                                  : (m.sender_type === 'Bot')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString($setup.t("bot_badge")), 1 /* TEXT */))
                                                    : _createCommentVNode("v-if", true),
                                                _createTextVNode(" " + _toDisplayString(m.author || $setup.t("support")), 1 /* TEXT */)
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["txc-bubble", { 'txc-bubble--ai': m.sender_type === 'AI' }]),
                                            innerHTML: m.content
                                          }, null, 10 /* CLASS, PROPS */, _hoisted_45),
                                          (m.sources && m.sources.length)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                _createElementVNode("span", null, _toDisplayString($setup.t("sources")) + ":", 1 /* TEXT */),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.sources, (s, i) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                                    (s.url)
                                                      ? (_openBlock(), _createElementBlock("a", {
                                                          key: 0,
                                                          href: s.url,
                                                          target: "_blank",
                                                          rel: "noopener"
                                                        }, _toDisplayString(s.title), 9 /* TEXT, PROPS */, _hoisted_47))
                                                      : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(s.title), 1 /* TEXT */))
                                                  ], 64 /* STABLE_FRAGMENT */))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          (m.can_feedback)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                                (!m.feedback)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createElementVNode("button", {
                                                        type: "button",
                                                        onClick: $event => ($setup.giveFeedback(m, 'Helpful'))
                                                      }, _toDisplayString($setup.t("helpful")), 9 /* TEXT, PROPS */, _hoisted_50),
                                                      _createElementVNode("button", {
                                                        type: "button",
                                                        onClick: $event => ($setup.giveFeedback(m, 'Not helpful'))
                                                      }, _toDisplayString($setup.t("not_helpful")), 9 /* TEXT, PROPS */, _hoisted_51)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                  : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString($setup.t("thanks_fb")), 1 /* TEXT */))
                                              ]))
                                            : _createCommentVNode("v-if", true),
                                          _createElementVNode("small", _hoisted_53, [
                                            _createTextVNode(_toDisplayString($setup.time(m.created)), 1 /* TEXT */),
                                            (m.from_customer && m.seen)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(" · " + _toDisplayString($setup.t("seen")), 1 /* TEXT */)
                                                ], 64 /* STABLE_FRAGMENT */))
                                              : _createCommentVNode("v-if", true)
                                          ])
                                        ], 2 /* CLASS */))
                                  ], 64 /* STABLE_FRAGMENT */))
                                }), 128 /* KEYED_FRAGMENT */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.pending, (p) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: p.cid,
                                    class: "txc-msg txc-msg--me"
                                  }, [
                                    (p.failed)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "txc-bubble txc-bubble--failed",
                                          onClick: $event => ($setup.retry(p))
                                        }, [
                                          _createTextVNode(_toDisplayString(p.text), 1 /* TEXT */),
                                          _createElementVNode("small", null, _toDisplayString($setup.t("failed")), 1 /* TEXT */)
                                        ], 8 /* PROPS */, _hoisted_54))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(p.text), 1 /* TEXT */))
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */)),
                                ($setup.state.ai)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                      _createElementVNode("small", _hoisted_57, [
                                        _createElementVNode("span", _hoisted_58, _toDisplayString($setup.t("ai_badge")), 1 /* TEXT */),
                                        _createTextVNode(_toDisplayString($setup.assistantName), 1 /* TEXT */)
                                      ]),
                                      _createElementVNode("div", _hoisted_59, [
                                        ($setup.state.ai.text)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString($setup.state.ai.text), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                        _hoisted_61
                                      ])
                                    ]))
                                  : ($setup.state.agent_typing)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                        _hoisted_63,
                                        _createTextVNode(" " + _toDisplayString($setup.fmt($setup.t("typing"), $setup.state.agent_name || $setup.t("support"))), 1 /* TEXT */)
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                ($setup.mode === 'guest' && $setup.phase === 'chat' && !$setup.agentReplied && $setup.state.handling !== 'Bot')
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString($setup.t("email_hint")), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                ($setup.phase === 'ended')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                      _createElementVNode("p", null, _toDisplayString($setup.expired ? $setup.t("expired") : $setup.t("ended")), 1 /* TEXT */),
                                      (!$setup.expired && !$setup.rated)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("p", _hoisted_66, _toDisplayString($setup.t("rate")), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_67, [
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                                                return _createElementVNode("button", {
                                                  key: n,
                                                  type: "button",
                                                  "aria-label": n + '/5',
                                                  onClick: $event => ($setup.rate(n))
                                                }, "★", 8 /* PROPS */, _hoisted_68)
                                              }), 64 /* STABLE_FRAGMENT */))
                                            ])
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : ($setup.rated)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString($setup.t("thanks")), 1 /* TEXT */))
                                          : _createCommentVNode("v-if", true),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "txc-btn",
                                        onClick: $setup.newChat
                                      }, _toDisplayString($setup.t("new_chat")), 1 /* TEXT */)
                                    ]))
                                  : _createCommentVNode("v-if", true)
                              ], 64 /* STABLE_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */),
              ($setup.phase === 'chat')
                ? (_openBlock(), _createElementBlock("footer", _hoisted_70, [
                    ($setup.chips.length && !$setup.confirmEnd)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chips, (c) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: c.label + c.payload,
                              type: "button",
                              class: _normalizeClass(["txc-qr", { 'txc-qr--agent': c.payload === '@agent' }]),
                              onClick: $event => ($setup.sendChip(c))
                            }, _toDisplayString(c.label), 11 /* TEXT, CLASS, PROPS */, _hoisted_72))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true),
                    ($setup.showDisclaimer)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString($setup.cfg.assistant.disclaimer), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.confirmEnd)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("span", null, _toDisplayString($setup.t("end_confirm")), 1 /* TEXT */),
                          _createElementVNode("button", {
                            type: "button",
                            class: "txc-btn txc-btn--ghost",
                            onClick: _cache[8] || (_cache[8] = $event => ($setup.confirmEnd = false))
                          }, _toDisplayString($setup.t("no")), 1 /* TEXT */),
                          _createElementVNode("button", {
                            type: "button",
                            class: "txc-btn",
                            onClick: $setup.endChat
                          }, _toDisplayString($setup.t("yes")), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("form", {
                          key: 3,
                          class: "txc-compose",
                          onSubmit: _withModifiers($setup.send, ["prevent"])
                        }, [
                          ($setup.mode === 'customer')
                            ? (_openBlock(), _createElementBlock("label", {
                                key: 0,
                                class: "txc-iconbtn",
                                title: $setup.t('attach')
                              }, [
                                _createElementVNode("input", {
                                  type: "file",
                                  hidden: "",
                                  onChange: $setup.pickFile
                                }, null, 32 /* NEED_HYDRATION */),
                                _hoisted_77
                              ], 8 /* PROPS */, _hoisted_76))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("div", _hoisted_78, [
                            ($setup.file)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_79, [
                                  _createTextVNode(_toDisplayString($setup.file.name) + " ", 1 /* TEXT */),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = $event => ($setup.file = null))
                                  }, "×")
                                ]))
                              : _createCommentVNode("v-if", true),
                            _withDirectives(_createElementVNode("textarea", {
                              id: "txc-draft",
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (($setup.draft) = $event)),
                              rows: "1",
                              placeholder: $setup.t('type'),
                              maxlength: $setup.cfg.max_length,
                              "aria-label": $setup.t('type'),
                              onKeydown: _withKeys(_withModifiers($setup.send, ["exact","prevent"]), ["enter"]),
                              onInput: $setup.onType
                            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_80), [
                              [_vModelText, $setup.draft]
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "txc-send",
                            disabled: !$setup.draft.trim() && !$setup.file,
                            "aria-label": $setup.t('send')
                          }, _hoisted_83, 8 /* PROPS */, _hoisted_81)
                        ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_75))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 8 /* PROPS */, _hoisted_6))
          : _createCommentVNode("v-if", true)
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}